import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Addons
 * @summary Delete addon (soft delete)
 */
export const DeleteAddonContentType = '' as const;
export type DeleteAddonRequest = void;
export type DeleteAddonResponses = LinkCommonErrorResponses & {
    /**
     * @description Addon deleted successfully
     */
    '200': {};
};
export type DeleteAddonResponseSuccess = undefined;
export type DeleteAddonSearchParams = undefined;
export type DeleteAddonPathParameters = {
    id: string;
};
export const DeleteAddonUrl = '/addons/{id}' as const;
export const DeleteAddonMethod = 'DELETE' as const;
export const getDeleteAddonUrl = (params: DeleteAddonPathParameters) =>
    DeleteAddonUrl.replace(/\{(\w+)\}/g, (_match, param: keyof DeleteAddonPathParameters) => String(params[param]));
